import { render, staticRenderFns } from "./QuestionnaireNotesDialog.vue?vue&type=template&id=c4937c04&scoped=true&"
import script from "./QuestionnaireNotesDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireNotesDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireNotesDialog.vue?vue&type=style&index=0&id=c4937c04&prod&lang=scss&scoped=true&"
import style1 from "./QuestionnaireNotesDialog.vue?vue&type=style&index=1&id=c4937c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4937c04",
  null
  
)

export default component.exports